import { makeAutoObservable } from 'mobx'
import { type RootStore } from './RootStore'
import { ComponentPropsWithoutRef, FunctionComponent } from 'react'

export interface Options {
  newStack?: boolean
}
interface StackDrawer<C extends FunctionComponent<React.PropsWithChildren<any>>> {
  component: C
  props?: ComponentPropsWithoutRef<C>
}

export class DrawersStore {
  rootStore: RootStore
  drawers: StackDrawer<FunctionComponent<React.PropsWithChildren<any>>>[] = []
  stackIndices: number[] = []
  snapResetObserver?: boolean

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)
    this.rootStore = rootStore
    this.snapResetObserver = undefined
  }

  openDrawer = <C extends FunctionComponent<React.PropsWithChildren<any>>>(
    component: C,
    props?: ComponentPropsWithoutRef<C>,
    options?: Options,
  ) => {
    if (options?.newStack) {
      this.stackIndices.push(this.drawers.length)
    }

    this.drawers.push({
      component,
      props,
    })
  }

  closeDrawer = () => {
    this.drawers = [...this.drawers].slice(0, this.drawers.length - 1)
    if (this.stackIndices.length > 0 && this.stackIndices[this.stackIndices.length - 1] === this.drawers.length) {
      this.stackIndices.pop()
    }
    this.snapResetObserver = undefined
  }

  closeAllDrawers = () => {
    this.stackIndices = []
    this.drawers = []
    this.snapResetObserver = undefined
  }

  closeStack = () => {
    const index = this.stackIndices.pop()
    if (index === undefined) {
      return
    }

    this.drawers = this.drawers.slice(0, index)
  }

  resetSnap = () => {
    this.snapResetObserver = !this.snapResetObserver
  }
}
